import { numberWithCommas } from '@/helpers/formatters';

export const calculatePercent = (value, total, asFloat = false) => {
  if (total === 0) return 0;
  const percent = (value / total) * 100;
  return asFloat ? percent : percent.toFixed(2);
};

export const formatValue = (value) => {
  if (value === null || value === undefined) return '';
  return numberWithCommas(value);
};

export const TABLE_KEYS_TO_EXCLUDE = ['id', 'rowClass', 'label', 'children'];
